import React from "react";
const data = [
    { sno: 1, name: "Prof. M. Ramanujam", from: "1954", to: "1957" },
    { sno: 2, name: "Prof. K. Pampapathi Rao", from: "1957", to: "1965" },
    { sno: 3, name: "Prof. K. S. Swamy", from: "1965", to: "1973" },
    { sno: 4, name: "Prof. G. Krishnan", from: "1973", to: "1975" },
    { sno: 5, name: "Prof. K. S. Swamy", from: "1975", to: "1981" },
    { sno: 6, name: "Prof. R. Ramamurthi", from: "03-07-1981", to: "30-04-1983" },
    { sno: 7, name: "Dr. P. Venkateswara Rao (Reader)", from: "01-05-1983", to: "01-12-1983" },
    { sno: 8, name: "Dr. B. Padmanabha Naidu (Reader)", from: "02-12-1983", to: "01-12-1985" },
    { sno: 9, name: "Dr. S. Govindappa (Reader)", from: "02-12-1985", to: "01-12-1987" },
    { sno: 10, name: "Dr. S. Indira Sriram (Reader)", from: "02-12-1987", to: "01-12-1989" },
    { sno: 11, name: "Dr. N. V. Nanda Kumar (Reader)", from: "02-12-1989", to: "01-12-1991" },
    { sno: 12, name: "Dr. P. Murali Mohan (Reader)", from: "02-12-1991", to: "15-10-1992" },
    { sno: 13, name: "Prof. R. Ramamurthi", from: "16-03-1993", to: "10-10-1994" },
    { sno: 14, name: "Prof. B. Padmanabha Naidu", from: "24-10-1994", to: "29-06-1996" },
    { sno: 15, name: "Prof. P. Venkateswara Rao", from: "30-06-1996", to: "30-09-1997" },
    { sno: 16, name: "Prof. S. Govindappa", from: "01-10-1997", to: "04-02-1999" },
    { sno: 17, name: "Prof. K. V. Ramana Rao", from: "05-02-1999", to: "31-10-2001" },
    { sno: 18, name: "Prof. N. V. Nanda Kumar", from: "01-11-2001", to: "20-01-2003" },
    { sno: 19, name: "Prof. K. Jayantha Rao", from: "21-01-2003", to: "20-01-2005" },
    { sno: 20, name: "Prof. G. Raja Rami Reddy", from: "21-01-2005", to: "13-10-2005" },
    { sno: 21, name: "Prof. M. Rajeswara Rao", from: "14-10-2005", to: "06-11-2007" },
    { sno: 22, name: "Prof. W. Rajendra", from: "07-11-2007", to: "06-11-2009" },
    { sno: 23, name: "Prof. K. Yellamma", from: "09-11-2009", to: "30-11-2011" },
    { sno: 24, name: "Prof. K. Sathyavelu Reddy", from: "01-12-2011", to: "16-05-2012" },
    { sno: 25, name: "Prof. M. Bhaskar", from: "02-07-2012", to: "31-08-2014" },
    { sno: 26, name: "Prof. P. Jacob Doss", from: "01-09-2014", to: "02-09-2016" },
    { sno: 27, name: "Prof. A. Usha Rani", from: "03-09-2016", to: "04-09-2018" },
    { sno: 28, name: "Prof. M. Srinivasulu Reddy", from: "05-09-2018", to: "06-09-2020" },
    { sno: 29, name: "Prof. P. Jacob Doss", from: "07-09-2020", to: "06-09-2022" },
    { sno: 30, name: "Prof. S. Kishore", from: "07-09-2022", to: "26-06-2024" },
    { sno: 31, name: "Prof. M. Rajasekhar", from: "27-06-2024", to: "Till Date" },


  ];
const Headsofthedepartment = () => {
    return (


        <div>
            <section className="about-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">Heads of the Department</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                        Heads of the Department</p>
                </div>
            </section>
            <section className="hod-main-sec text-center">
            <p className="ab-depart-subheading">Department of Zoology</p>
            <p className="home-about-head">Heads of the Department</p>

            <div className="hod-table-container">
      <table className="hod-table">
        <thead>
          <tr>
            <th>S No</th>
            <th>Head of the Department</th>
            <th colSpan="2">Tenure Period</th>
          </tr>
          <tr>
            <th></th>
            <th></th>
            <th>From</th>
            <th>To</th>
          </tr>
        </thead>
        <tbody>
          {data.map((hod) => (
            <tr key={hod.sno}>
              <td>{hod.sno}</td>
              <td>{hod.name}</td>
              <td>{hod.from}</td>
              <td>{hod.to}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
            </section>
        </div>
    )
}
export default Headsofthedepartment